import React, { useState } from "react";
import cx from "classnames";
import Input from "../Input";

import useValidations from "../../../utils/useValidations";
import useAppContext from "../../AppContext";
import useForceValidate from "../../../utils/useForceValidate";

import ErrorSwitch from "../../ErrorSwitch";
import ConditionalWrapper from "../../ConditionalWrapper";
import useDistributedValidator from "../../../utils/useDistributedValidator";

export default function Textfield({
  id,
  name,
  onChange: broadcastChange,
  value: defaultValue,
  rules,
  styles,
  disabled = false,
  placeholder = "",
  withAutofocus = true,
  wrapperClassName = "",
  inputWrapperClassName = "",
  inputPreset,
  Icon,
  regexReplace,
  ...rest
}) {
  const [value, setValue] = useState(() => defaultValue);
  const { newQuiz, forceValidation } = useAppContext();
  const [isValid, validations, validate] = useValidations(rules.validators);

  const { hasTriggered } = useForceValidate({
    trigger: forceValidation,
    validate: () => validate(value || "")
  });

  useDistributedValidator(() => {
    return {
      [name]: validate(value)?.[0]
    };
  });

  const onChange = ev => {
    let { name: key, value } = ev.target;
    if (regexReplace) {
      value = value.replace(regexReplace, "");
    }
    setValue(value);
    value = validate(value)[0] ? value : null;
    broadcastChange(key, value);
  };

  const renderError =
    !newQuiz.isSequence || (newQuiz.isSequence && hasTriggered);

  return (
    <ConditionalWrapper
      condition={newQuiz.isSequence || newQuiz.isUni3 || newQuiz.isUni4}
      wrapper={children => (
        <div
          className={cx(styles.fieldsetWrapperNewQuiz, {
            [wrapperClassName]: wrapperClassName
          })}
        >
          {children}
        </div>
      )}
    >
      <>
        <div
          className={cx(styles.fieldsetWrapperNewQuiz, {
            [inputWrapperClassName]: inputWrapperClassName
          })}
        >
          <Input
            id={id}
            value={value ?? ""}
            name={name}
            onChange={onChange}
            error={!isValid}
            placeholder={placeholder}
            autoFocus={withAutofocus}
            disabled={disabled}
            preset={inputPreset}
            {...rest}
          />
          {newQuiz.isSequence && Icon && <Icon />}
        </div>
        {renderError && (
          <ErrorSwitch
            name={`textfield-${id}-form`}
            validations={validations}
            className={styles.inputErrorNewQuiz}
          >
            {rules.errorMessages}
          </ErrorSwitch>
        )}
      </>
    </ConditionalWrapper>
  );
}
